import { Controller } from "@hotwired/stimulus"

// Preenche o campo de senha com uma senha forte aleatória.
// Usa crypto.getRandomValues (CSPRNG) — Math.random() é previsível
// e nunca deve ser usado para gerar segredos.
const CHARSET =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*-_=+"
const LENGTH = 20

export default class extends Controller {
  static targets = ["field"]

  generate() {
    const random = new Uint32Array(LENGTH)
    crypto.getRandomValues(random)

    this.fieldTarget.value = Array.from(
      random,
      (n) => CHARSET[n % CHARSET.length]
    ).join("")

    // Mostra o que foi gerado: o usuário precisa poder ver/copiar a senha nova.
    this.fieldTarget.type = "text"
    this.fieldTarget.focus()
  }
}
